import React from 'react'

const Resources = () => {
  return (
  <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      position: 'relative',
      overflow: 'hidden'
  }}>
      <div style={{
          textAlign: 'center',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(10px)',
          maxWidth: '600px',
          width: '90%',
          position: 'relative',
          zIndex: 1
      }}>
          <h1 style={{
              fontSize: '3.5rem',
              color: '#2d3748',
              marginBottom: '1rem',
              fontWeight: '700',
              background: 'linear-gradient(45deg, #4677F7, #7703FC)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
          }}>Coming Soon</h1>
          <p style={{
              fontSize: '1.25rem',
              color: '#4a5568',
              marginBottom: '2rem',
              lineHeight: '1.6'
          }}>We're working on something exciting!</p>
          <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem',
              marginTop: '2rem'
          }}>
              {[1, 2, 3].map((_, index) => (
                  <div key={index} style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      background: 'linear-gradient(45deg, #4677F7, #7703FC)',
                      animation: `bounce 1.4s infinite ease-in-out ${index * 0.16}s`
                  }}></div>
              ))}
          </div>
      </div>
  </div>
  )
}

export default Resources